import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import {
  Text,
  Image,
  mergeClasses,
  makeStyles,
  tokens,
} from '@fluentui/react-components';
import { I18nContext } from '@bingads-webui-react/i18n-context';

const useAppItemStyles = makeStyles({
  appItem: {
    display: 'flex',
  },
  image: {
    width: '40px',
    height: '40px',
  },
  details: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center',
    marginLeft: '8px',
  },
  name: {
    fontWeight: 'bold',
    lineHeight: '20px',
    color: tokens.colorNeutralForeground1,
  },
});

export const AppItem = (props) => {
  const {
    appTitle,
    appLogoUrl,
    appCountryCode,
  } = props;

  const i18n = useContext(I18nContext);

  const classes = useAppItemStyles();
  const country = appCountryCode ? `Country: ${appCountryCode}` : i18n.getString(_TL_('United States'));

  return (
    <div className={mergeClasses('app-page-item', classes.appItem)}>
      <Image src={appLogoUrl} className={classes.image} />
      <div className={classes.details}>
        <Text className={mergeClasses('app-page-name', classes.name)}>
          {appTitle}
        </Text>
        <Text className={mergeClasses('app-page-country', classes.details)}>
          {country}
        </Text>
      </div>
    </div>
  );
};

AppItem.propTypes = {
  appTitle: PropTypes.string.isRequired,
  appLogoUrl: PropTypes.string,
  appCountryCode: PropTypes.string,
};

AppItem.defaultProps = {
  appLogoUrl: '',
  appCountryCode: '',
};
